/**
 * This file extracts client environment variables from process.env
 * You can't destructure `process.env` as a regular object, so you have to do
 * it manually here. This is because Next.js evaluates this at build time,
 * and only used environment variables are included in the build.
 */

// Hack to cast string to type 'pet' | 'vet' | 'farm' | 'corporate' | undefined
const TOWER = process.env.NEXT_PUBLIC_TOWER as
	| 'pet'
	| 'vet'
	| 'farm'
	| 'corporate'
	| undefined

export const clientEnv = {
	NEXT_PUBLIC_KONTENT_PROJECT_ID:
		process.env.NEXT_PUBLIC_KONTENT_PROJECT_ID ?? '',
	NEXT_PUBLIC_APPINSIGHTS_CONNECTION_STRING:
		process.env.NEXT_PUBLIC_APPINSIGHTS_CONNECTION_STRING,
	NEXT_PUBLIC_TOWER: TOWER,
	NEXT_PUBLIC_SEARCH_API_KEY: process.env.NEXT_PUBLIC_SEARCH_API_KEY,
	NEXT_PUBLIC_MAP_API_KEY: process.env.NEXT_PUBLIC_MAP_API_KEY,
	NEXT_PUBLIC_FAQ_COGNITIVE_SEARCH_API_KEY:
		process.env.NEXT_PUBLIC_FAQ_COGNITIVE_SEARCH_API_KEY,
	NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,
	NEXT_PUBLIC_REBATES_API_URL: process.env.NEXT_PUBLIC_REBATES_API_URL,
	NEXT_PUBLIC_TRUSTCODE_HOST: process.env.NEXT_PUBLIC_TRUSTCODE_HOST,
	NEXT_PUBLIC_FEATURE_FLAG_COUNTRY_SELECTOR:
		process.env.NEXT_PUBLIC_FEATURE_FLAG_COUNTRY_SELECTOR,
	NEXT_PUBLIC_CWV_APP_INSIGHTS_SAMPLE_RATE:
		process.env.NEXT_PUBLIC_CWV_APP_INSIGHTS_SAMPLE_RATE,
	NEXT_PUBLIC_CWV_GTM_SAMPLE_RATE:
		process.env.NEXT_PUBLIC_CWV_GTM_SAMPLE_RATE,
	NEXT_PUBLIC_CWV_DEBUG_LOGGING: process.env.NEXT_PUBLIC_CWV_DEBUG_LOGGING,
	NEXT_PUBLIC_NODE_ENV: process.env.NODE_ENV,
	NEXT_PUBLIC_PARASITE_MAP_STYLE_ID:
		process.env.NEXT_PUBLIC_PARASITE_MAP_STYLE_ID,
	NEXT_PUBLIC_EMAIL_FOR_PET_LOGIN:
		process.env.NEXT_PUBLIC_EMAIL_FOR_PET_LOGIN,
	NEXT_PUBLIC_PASS_FOR_PET_LOGIN: process.env.NEXT_PUBLIC_PASS_FOR_PET_LOGIN,
	NEXT_PUBLIC_EMAIL_FOR_VET_LOGIN:
		process.env.NEXT_PUBLIC_EMAIL_FOR_VET_LOGIN,
	NEXT_PUBLIC_PASS_FOR_VET_LOGIN: process.env.NEXT_PUBLIC_PASS_FOR_VET_LOGIN,
}
